import { request } from 'umi';
import type { MallCommodityCategoryParams, CommodityShareQrCodeParams } from './data';

//获取分页数据
export async function getMallCommodityCategory(params: MallCommodityCategoryParams) {
  return request('/hm/mall/commodity/pageSearch',{params});
}

//获取店铺list列表
export async function getShopPageSearch(params: any) {
  return request('/hm/mall/shop/pageSearch', {params})
}

//获取商品类目list列表
export async function getCategoryPageSearch(params: any) {
  return request('/hm/mall/category/pageSearch', {params})
}

// 更新状态 /mall/commodity/updateShelfStatus
export async function changeUpdateShelfStatus(params: {commodityId: string, shelfStatus: number}){
  return request('/hm/mall/commodity/updateShelfStatus', {
    method:'POST',
    params
  })
}

//删除商品 /mall/commodity/batch/remove
export async function deleteBatchRemoce(params:{ids: string}) {
  return request('/hm/mall/commodity/batch/remove', {
    method:'POST',
    params
  })
}

/** hm -- 健康商城-商品相关 -- 分享二维码[管理后台]
 * @method GET
 * @url /hm/mall/commodity/shareQrCode
 * @param {String} appId          *客户端id
 * @param {String} commodityId    *商品id
 */
export async function getCommidityShareQrCode(params: CommodityShareQrCodeParams) {
  return request('/hm/mall/commodity/shareQrCode', { params })
}
